const prefix = 'feature-flag';

export const get_feature_flags = `${prefix}`;
export const enable_feature_flag = (id: string) => `${prefix}/${id}/enable`;
export const disable_feature_flag = (id: string) => `${prefix}/${id}/disable`;
export const update_feature_flag = (id: string) => `${prefix}/${id}`;
